import {identifierIds} from "./statesAndIdentifiers";

export function handleModalLogic(shipmentList = [], orderId) {
  const shipmentModal = document.querySelector(identifierIds.SHIPMENTS_MODAL);
  const searchInput = shipmentModal.querySelector(".shipments-modal-input");
  const previousBtn = shipmentModal.querySelector(".shipments-modal-previous");
  const nextBtn = shipmentModal.querySelector(".shipments-modal-next");
  const shipmentListWrapper = shipmentModal.querySelector(
    ".shipments-modal-list",
  );
  const shipmentListWrapperMweb = shipmentModal.querySelector(
    ".shipments-modal-list-mweb",
  );
  const shipmentsListContainer = shipmentModal.querySelector(
    ".shipments-modal-list-wrapper",
  );
  const shipmentsListContainerMweb = shipmentModal.querySelector(
    ".shipments-modal-list-wrapper-mweb",
  );
  const previousBtnText = shipmentModal.querySelector(
    ".shipments-modal-previous-text",
  );
  const nextBtnText = shipmentModal.querySelector(".shipments-modal-next-text");

  const previousBtnIcon = shipmentModal.querySelector(
    ".shipments-modal-previous-icon",
  );
  const nextBtnIcon = shipmentModal.querySelector(".shipments-modal-next-icon");
  const previousBtnIconDisabled = shipmentModal.querySelector(
    ".shipments-modal-previous-icon-disabled",
  );
  const nextBtnIconDisabled = shipmentModal.querySelector(
    ".shipments-modal-next-icon-disabled",
  );

  const shipmentsModalFooter = shipmentModal.querySelector(
    ".shipments-modal-footer",
  );

  const shipmentsModalHeading = shipmentModal.querySelector(
    ".shipments-modal-heading",
  );
  const shipmentsModalHeadingMweb = shipmentModal.querySelector(
    ".shipments-modal-heading-mweb",
  );
  const shipmentsModalNoResults = shipmentModal.querySelector(
    ".shipments-modal-no-results",
  );

  const shipmentsModalCross = shipmentModal.querySelector(
    ".shipments-modal-cross",
  );
  const shipmentsModalListHeader = shipmentModal.querySelector(
    ".shipments-modal-list-header",
  );

  const shipmentsModalListHeaderMweb = shipmentModal.querySelector(
    ".shipments-modal-list-header-mweb",
  );

  const PEC = JSON.parse(sessionStorage.getItem("labels_config"));

  let currentPage = 1;
  const itemsPerPage = 5;
  let searchFiltered = shipmentList;

  const disablePreviousBtn = () => {
    previousBtnIconDisabled.style.display = "block";
    previousBtnIcon.style.display = "none";
    previousBtnText.style.color = "#e0e3eb";
    previousBtn.style.cursor = "default";
  };
  const enablePreviousBtn = () => {
    previousBtnIconDisabled.style.display = "none";
    previousBtnIcon.style.display = "block";
    previousBtnText.style.color = "#525b7a";
    previousBtn.style.cursor = "pointer";
  };

  const disableNextBtn = () => {
    nextBtnIconDisabled.style.display = "block";
    nextBtnIcon.style.display = "none";
    nextBtnText.style.color = "#e0e3eb";
    nextBtn.style.cursor = "default";
  };

  const enableNextBtn = () => {
    nextBtnIconDisabled.style.display = "none";
    nextBtnIcon.style.display = "block";
    nextBtnText.style.color = "#525b7a";
    nextBtn.style.cursor = "pointer";
  };

  const searchFilter = () => {
    searchFiltered = shipmentList.filter((shipment) =>
      shipment.toLowerCase()?.includes(searchInput?.value?.toLowerCase() || ""),
    );
  };

  const updatePagination = () => {
    if (currentPage === 1) {
      disablePreviousBtn();
    } else {
      enablePreviousBtn();
    }

    if (currentPage === Math.ceil(searchFiltered?.length / itemsPerPage)) {
      disableNextBtn();
    } else {
      enableNextBtn();
    }

    if (searchFiltered?.length <= itemsPerPage) {
      shipmentsModalFooter.classList.add("hide");
    } else {
      shipmentsModalFooter.classList.remove("hide");
    }
  };

  const filterList = (start, end) => {
    searchFilter();
    const pageFiltered = searchFiltered.slice(start, end);
    return pageFiltered;
  };

  const createList = (filterList = []) => {
    return filterList
      .map((item) => `<span class="shipment-modal-list-item">${item}</span>`)
      .join("");
  };

  const createListMweb = (filterList = []) => {
    return filterList
      .map(
        (item) => `<span class="shipment-modal-list-item-mweb">${item}</span>`,
      )
      .join("");
  };

  const updateShipmentList = () => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    const filteredList = filterList(start, end);
    const createdList = createList(filteredList);
    shipmentListWrapper.innerHTML = createdList;

    if (createdList.length === 0) {
      shipmentsModalNoResults.classList.remove("hide");
      shipmentsListContainer.classList.add("hide");
      shipmentsModalFooter.classList.add("hide");
    } else {
      shipmentsModalNoResults.classList.add("hide");
      shipmentsListContainer.classList.remove("hide");
      shipmentsModalFooter.classList.remove("hide");
    }

    updatePagination();
  };

  const updateShipmentListMweb = () => {
    searchFilter();
    const createdList = createListMweb(searchFiltered);
    shipmentListWrapperMweb.innerHTML = createdList;

    if (createdList.length === 0) {
      shipmentsModalNoResults.classList.remove("hide");
      shipmentsListContainerMweb.classList.add("hide");
    } else {
      shipmentsModalNoResults.classList.add("hide");
      shipmentsListContainerMweb.classList.remove("hide");
    }
  };

  updateShipmentList();
  updateShipmentListMweb();
  shipmentsModalHeading.textContent = `${PEC?.shipments?.plural || ""} (${shipmentList.length || ""})`;
  shipmentsModalHeadingMweb.textContent = `Order ID #${orderId || ""}`;
  shipmentsModalListHeaderMweb.textContent = `${PEC?.shipments?.plural || ""}: ${shipmentList.length || ""}`;
  shipmentsModalListHeader.textContent = `${PEC?.shipments?.singular || ""} ID`;
  searchInput.placeholder = `Search by ${PEC?.shipments?.singular || ""} ID`;

  searchInput.addEventListener("input", () => {
    currentPage = 1;
    updateShipmentList();
    updateShipmentListMweb();
  });

  previousBtn.addEventListener("click", () => {
    if (currentPage > 1) {
      currentPage--;
      updateShipmentList();
    }
  });

  nextBtn.addEventListener("click", () => {
    if (currentPage < Math.ceil(searchFiltered?.length / itemsPerPage)) {
      currentPage++;
      updateShipmentList();
    }
  });

  shipmentsModalCross.addEventListener("click", () => {
    shipmentModal.classList.remove("visible");
    document.body.style.overflow = "auto";
  });

  // close modal when clicked outside
  shipmentModal.addEventListener("click", (e) => {
    const isOutside = !e.target.closest(".shipments-modal-wrapper");
    if (isOutside) {
      shipmentModal.classList.remove("visible");
      document.body.style.overflow = "auto";
    }
  });
}
